import { LoginActions } from "./Login.actions";
import { initialState } from "redux/initialState";
import { LoginState, User } from "models";

export const loginReducer = (state: LoginState = initialState.login, action: { type: string; payload?: User | boolean | string }) => {
  switch (action.type) {
    case LoginActions.LoginIsLoggingIn:
      return { ...state, isLoggingIn: action.payload as boolean };
    case LoginActions.LoginSuccessful:
      return { ...state, isLoggedIn: true, isLoggingIn: false, loginFailure: "", user: action.payload as User };
    case LoginActions.LoginFailed:
      return { ...state, isLoggedIn: false, isLoggingIn: false, loginFailure: action.payload as string };
    case LoginActions.Logout:
      return { ...state, isLoggedIn: false, isLoggingIn: false, loginFailure: "" };
    default:
      return state;
  }
};
